import { render, staticRenderFns } from "./TransactionTabs.vue?vue&type=template&id=12b36db7&scoped=true"
import script from "./TransactionTabs.vue?vue&type=script&lang=js"
export * from "./TransactionTabs.vue?vue&type=script&lang=js"
import style0 from "./TransactionTabs.vue?vue&type=style&index=0&id=12b36db7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b36db7",
  null
  
)

export default component.exports